import ControlFactory from '@/Factories/ControlFactory';
import LDAPUsersViewModel from '@/ViewModels/Controls/LDAPUsersViewModel';
import LDAPUsers from '@/Controls/LDAPUsers';
import LDAPUsersViewModelT from '@/ViewModels/Controls/LDAPUsersViewModel';
import ComponentManager from '@/Management/ComponentManager';
import { IControlFactoryConstructorParameter } from "#/CoreFrameInterfaces";

export default class LDAPUsersFactory extends ControlFactory {
    /**
     * @override
     */
    public control: LDAPUsers;

    /**
     * @override
     */
    public viewModel: LDAPUsersViewModel;

    private readonly LDAPUsersViewModel = ComponentManager.getViewModel<typeof LDAPUsersViewModelT>('LDAPUsersViewModel');
    private readonly LDAPUsers = ComponentManager.getControl<typeof LDAPUsers>('LDAPUsers');

    private jQueryControl: JQuery;

    constructor(params: IControlFactoryConstructorParameter) {
        super(params);

        this.jQueryControl = null;
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.labelPosition = 'None';
        this.colspan = 'Fill';

        const genericObject = this.context.genericObject;
        this.viewModel = new this.LDAPUsersViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            detailViewContext: this.context,
            username: genericObject.getObservable<string>('Username'),
            firstName: genericObject.getObservable<string>('FirstName'),
            lastName: genericObject.getObservable<string>('LastName'),
            email: genericObject.getObservable<string>('Email'),
            company: genericObject.getObservable<string>('Company'),
            language: genericObject.getObservable<string>('Language'),
            extension1: genericObject.getObservable<string>('Extension1'),
            extension2: genericObject.getObservable<string>('Extension2'),
            extension3: genericObject.getObservable<string>('Extension3'),
            memberOf: genericObject.getObservable<string>('MemberOf'),
            search: genericObject.getObservable<any>(this.detailViewItem.name + '.Search'),
            reset: genericObject.getObservable<any>(this.detailViewItem.name + '.Reset')
        });

        this.control = new this.LDAPUsers(this.viewModel);
        const tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('LDAPUsers', LDAPUsersFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');